import React, { useEffect, useRef, useState } from 'react';
import { db } from '../../utils/firebase';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { sendMessage } from '../../utils/chat';

const ChatPanel = ({ user,otherProfileName, conversationId, onClose }) => {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState('');
  const endRef = useRef(null);

  useEffect(() => {
    if (!conversationId) return;
    const q = query(
      collection(db, 'conversations', conversationId, 'messages'),
      orderBy('createdAt', 'asc')
    );
    const off = onSnapshot(q, (snap) =>
      setMessages(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
    return () => off();
  }, [conversationId]);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const send = async () => {
    await sendMessage({ conversationId, text, senderId: user?.uid });
    setText('');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <button className="absolute inset-0 bg-black/50" onClick={onClose} aria-label="Close backdrop" />
      {/* Panel */}
      <div className="relative z-10 w-full max-w-xl h-[80vh] bg-white rounded-2xl shadow-xl flex flex-col">
        <div className="p-4 border-b flex items-center justify-between">
          <h2 className="text-lg font-semibold">Conversation with {otherProfileName}</h2>
          <button
            onClick={onClose}
            className="px-3 py-1 rounded-md border text-sm"
          >
            Close
          </button>
        </div>

        <main className="flex-1 overflow-y-auto p-4 space-y-2">
          {messages.map((m) => {
            const mine = m.senderId === user?.uid;
            return (
              <div
                key={m.id}
                className={`max-w-[75%] px-3 py-2 rounded-2xl ${
                  mine ? 'bg-purple-600 text-white ml-auto' : 'bg-gray-100'
                }`}
              >
                <div className="whitespace-pre-wrap">{m.text}</div>
              </div>
            );
          })}
          <div ref={endRef} />
        </main>

        <div className="p-3 border-t flex gap-2">
          <textarea
            className="flex-1 border rounded-xl p-3 h-[56px]"
            placeholder="Type a message…"
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
            }}
          />
          <button
            onClick={send}
            className="px-4 rounded-xl bg-gradient-to-r from-[#6B01D1] to-[#F2787A] text-white font-semibold"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatPanel;
